<div class="main-content">
  <div>
    <ion-grid>
      <ion-row>
        <!-- Controls and Filters -->
        <ion-col size="12">
          <div class="flexed-align-center" style="margin: 15px 10px">
            <!-- Metric Selector -->
            <ion-button
              color="dark"
              fill="clear"
              class="button-dark-border btn-small"
              (click)="selectMetric($event)"
            >
              <ion-icon name="analytics" class="filter-button-icon"></ion-icon>
              <span class="hidden-sm">{{ getMetricLabel() }}</span>
              <ion-icon
                name="chevron-down-outline"
                class="filter-button-caret"
              ></ion-icon>
            </ion-button>

            <!-- Date Range Button -->
            <ion-button
              color="dark"
              fill="clear"
              class="button-dark-border btn-small"
              (click)="showDateRangeOptions($event)"
            >
              <ion-icon name="calendar" class="filter-button-icon"></ion-icon>
              <span class="hidden-sm">{{ dateRange.label }}</span>
              <ion-icon
                name="chevron-down-outline"
                class="filter-button-caret"
              ></ion-icon>
            </ion-button>

            <!-- Date Dimension (Daily/Weekly/Monthly) -->
            <ion-button
              color="dark"
              fill="clear"
              class="button-dark-border btn-small"
              (click)="showDateDimensionOptions($event)"
            >
              <ion-icon name="bar-chart" class="filter-button-icon"></ion-icon>
              <span class="hidden-sm">{{ dateDimensionLabel }}</span>
              <ion-icon
                name="chevron-down-outline"
                class="filter-button-caret"
              ></ion-icon>
            </ion-button>

            <!-- Filter Button (reusable component) -->
            <app-filter-button
              [options]="filterOptions"
              (didChange)="filtersDidChange($event)"
              [selected]="filters"
              [projectId]="authService.selectedProject?.id ?? undefined"
              [allowNotEqualsOperator]="true"
            ></app-filter-button>
          </div>

          <!-- Dimension Tabs and Chart -->
          <ion-card class="outline-card">
            <!-- Dimension Tabs -->
            <div style="margin: 15px 10px" class="hidden-sm">
              <p style="font-size: 0.8rem; opacity: 0.5; margin-left: 5px">
                <strong>Results</strong> broken down by:
              </p>
              <ng-container *ngFor="let dimension of DIMENSIONS_LIST">
                <span
                  class="tab-nav-link"
                  [ngClass]="{ 'tab-nav-active': isDimensionActive(dimension) }"
                  (click)="setDimension(dimension)"
                  style="font-size: 0.7rem"
                >
                  <ion-icon
                    [name]="
                      isDimensionActive(dimension)
                        ? dimension.icon
                        : dimension.icon + '-outline'
                    "
                  >
                  </ion-icon>
                  {{ dimension.label }}
                </span>
              </ng-container>
            </div>

            <!-- Chart -->
            <ion-card-content>
              <div
                *ngIf="!isLoading"
                style="
                  position: relative;
                  height: 520px;
                  width: 100%;
                  margin: auto;
                "
              >
                <canvas
                  #chart
                  baseChart
                  [datasets]="chartData"
                  [labels]="chartLabels"
                  [options]="chartOptions"
                >
                </canvas>
              </div>

              <!-- Loading state -->
              <div
                *ngIf="isLoading"
                style="
                  height: 520px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <ion-spinner></ion-spinner>
              </div>
            </ion-card-content>
          </ion-card>
        </ion-col>

        <!-- Table View -->
        <ion-col size="12">
          <ion-card class="outline-card">
            <ion-card-title class="card-title">
              <h3>Results</h3>
            </ion-card-title>
            <ngx-datatable
              class="material"
              [limit]="100"
              [headerHeight]="50"
              [footerHeight]="50"
              [rowHeight]="50"
              [scrollbarH]="true"
              [rows]="tabularData"
              [reorderable]="true"
              [loadingIndicator]="isLoading"
            >
              <!-- Dimension Column -->
              <ngx-datatable-column
                [name]="getDimensionLabel()"
                prop="dimensionLabel"
                [sortable]="false"
                [frozenLeft]="true"
                [width]="250"
              >
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.dimensionLabel }}
                </ng-template>
              </ngx-datatable-column>

              <!-- Date Columns -->
              <ngx-datatable-column
                *ngFor="let column of columns"
                [name]="getColumnName(column)"
                [prop]="column"
                [sortable]="true"
                [width]="115"
              >
                <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value | number }}
                </ng-template>
              </ngx-datatable-column>

              <!-- Total Column -->
              <ngx-datatable-column
                name="Total"
                prop="total"
                [sortable]="true"
                [width]="115"
              >
                <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value | number }}
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>
